import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{
    isAllTermSelected: boolean;
}>;

export const DispatchSelectedAllTerms: HandlerType = props => {
    props.dispatch({
        type: "Custom/Terms/SelectedAllTerms",
        isAllTermSelected: props.parameter.isAllTermSelected,
    });
};

export const chain = [DispatchSelectedAllTerms];

const selectAllTerms = createHandlerChainRunner(chain, "selectAllTerms");
export default selectAllTerms;
